export default __webpack_public_path__ + "static/media/team_bg_blue_1.31765509.png";